<template>
  <div id="appointment-information">

    <h4 class="mb-4">{{ $t('homelab.labels.appointment_info') }}</h4>

    <div class="row">
      <div class="col-12 col-md-6 mb-3" v-if="appointment.entity_of_origin">
        <label class="is-bold mb-0">{{ $t('people_manager.table.originEntity') }}</label>
        <br>
        <span>{{ appointment.entity_of_origin.name }}</span>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.entity') }}</label>
        <br>
        <span>{{ appointment.entity.name }}</span>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.facility') }}</label>
        <br>
        <span>{{ appointment.facility ? appointment.facility.name : $t('homelab.unassigned') }}</span>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.selected_time') }}</label>
        <br>
        <span>{{ getFormatedSelectedTime(appointment.selected_time) }}</span>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.scheduled_time') }}</label>
        <br>
        <span>{{ getFormatedScheduledTime(appointment.scheduled_time_start, appointment.scheduled_time_end) }}</span>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.collect_at_home') }}</label>
        <br>
        <span>{{ appointment.collect_at_home ? $t('homelab.labels.yes') : $t('homelab.labels.no') }}</span>
      </div>

      <div v-if="appointment.event_code" class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.event_code') }}</label>
        <br>
        <span>{{ appointment.event_code }}</span>
      </div>

      <div class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.has_medical_prescription') }}</label>
        <br>
        <span>{{ appointment.has_medical_prescription ? $t('homelab.labels.yes') : $t('homelab.labels.no') }}</span>
      </div>

      <div class="col-12 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.appointment_type') }}</label>
        <br>
        <span>{{ getFormatedAppointmentType(appointment) }}</span>

        <span v-if="appointment.insurer && appointment.insurance_card_nr">
          --- <label>{{ $t('homelab.labels.insurer_card_nr') }} - {{ appointment.insurance_card_nr }}</label>
        </span>

      </div>

      <div class="col-12 col-md-6 mb-3">
        <label class="is-bold mb-0">{{ $t('homelab.labels.total_price') }}</label>
        <br>
        <span>{{ appointment.total_price !== null ? `${appointment.total_price} €` : $t('homelab.unassigned') }}</span>
      </div>


      <div class="col-12">
        <hr>
        <h6 class="mb-3 mt-2">{{ $t('homelab.labels.prescription_info') }}</h6>

        <div class="row" v-if="appointment.prescriptions[0].code_nr === null && appointment.prescriptions[0].access_code === null && appointment.prescriptions[0].prescription_code === null">
          <div class="col-12 col-md-3 mb-3">
            <span> N/A </span>
          </div>
        </div>
        <div v-else class ="row" v-for="elem in appointment.prescriptions">
          <div class="col-12 col-md-3 mb-3">
            <label class="is-bold mb-0">{{ $t('homelab.labels.code_nr') }}</label>
            <br>
            <span>{{ elem.code_nr ? elem.code_nr : "N/A" }}</span>
          </div>

          <div class="col-12 col-md-3 mb-3">
            <label class="is-bold mb-0">{{ $t('homelab.labels.access_code') }}</label>
            <br>
            <span>{{ elem.access_code ? elem.access_code : "N/A" }}</span>
          </div>

          <div class="col-12 col-md-3 mb-3">
            <label class="is-bold mb-0">{{ $t('homelab.labels.prescription_code') }}</label>
            <br>
            <span>{{ elem.prescription_code ? elem.prescription_code : "N/A" }}</span>
          </div>
        </div>

      </div>



    </div>

  </div>
</template>

<script>
export default {
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  methods: {
    getFormatedSelectedTime: function (date) {
      date = this.moment(this.$options.filters.localTime(date))
      return `${date.format('YYYY-MM-DD')} ${this.$t('date_helpers.hour_to')} ${date.format('HH:mm')}`
    },
    getFormatedScheduledTime: function (start, end) {
      if (start && end) {
        start = this.moment(this.$options.filters.localTime(start))
        end = this.moment(this.$options.filters.localTime(end))
        return `${start.format('YYYY-MM-DD')} ${this.$t('date_helpers.hour_from')} ${start.format('HH:mm')} ${this.$t('date_helpers.hour_to')} ${end.format('HH:mm')}`
      } else {
        return this.$t('homelab.unassigned')
      }
    },
    getFormatedAppointmentType: function (appointment) {
      if (appointment.packages.length > 0) {

        let packages = []
        let charCounter = 0
        let hasMorePackages = false

        for (let i = 0; i < appointment.packages.length; i++) {
          if (charCounter + appointment.packages[i].name.length <= 50) {
            packages.push(appointment.packages[i].name)
          } else {
            hasMorePackages = i < appointment.packages.length
            i = appointment.packages.length
          }
        }

        let formatedAppointmentType = packages.join('; ')

        if (hasMorePackages) {
          formatedAppointmentType = `${formatedAppointmentType} (...)`
        }

        return formatedAppointmentType

      } else if (appointment.insurer) {
        if (appointment.insurer.id === 1) {
          return appointment.insurer.short_name
        } else {
          return `${this.$t('homelab.insurer')} - ${appointment.insurer.short_name}`
        }
      }
    }
  }
}
</script>
